export default {
    cta: "Kérdezzen egyet<br/> Tanácsadó",
    ordered: "Rendelés dátuma: {date}"
}